<template>
  <div>
    <ModalControl
      @closed="closed"
      v-bind:show="display"
      v-bind:title="lang('lbl_0000106')"
      theme="success"
      dismiss
    >
      <div class="w-full text-center">
        <div class="w-full">
          <img v-bind:src="getCode()" class="block" />
        </div>
      </div>
    </ModalControl>
    <div class="bg-primary w-full">
      <div class="flex pb-4 px-3">
        <div class="flex-grow">
          <div
            class="bg-white rounded mx-auto mt-6 shadow-md papsi-avatar overflow-hidden flex justify-center items-center"
          >
            <!-- <img
              v-if="loaded"
              v-on:click="openQr"
              v-bind:src="getCode()"
              class="block"
            /> -->
            <qrcode-vue v-if="loaded" :value="getCode()" :size="125" level="H" />
            <img
              v-else
              class="h-spinner w-spinner"
              src="@/assets/icons/papsi_spinner.svg"
              alt="Loading..."
            />
          </div>
          <div
            v-text="name"
            class="text-center text-white text-xl font-bold pt-5"
          ></div>
          <div
            class="flex flex-row justify-center items-center text-sm text-white p-2 mt-1 space-x-5"
          >
            <div class="flex flex-row items-center space-x-1">
              <div
                v-text="lang('lbl_0000093')"
                class="font-bold truncate mr-2"
              ></div>
              <div v-text="account_no" class="pt-[2px]"></div>
            </div>
            <div v-if="serial_no" class="h-4 border-l border-white mx-3"></div>
            <div v-if="serial_no" class="flex flex-row items-center space-x-1">
              <div
                v-text="lang('lbl_0000094')"
                class="font-bold truncate mr-2"
              ></div>
              <div v-text="getSerial()" class="pt-[2px]"></div>
            </div>
          </div>
          <div
  class="flex justify-center mt-2"
>
  <div
    class="flex flex-row items-center text-sm bg-secondary text-primary p-2 px-4 font-bold rounded-full w-fit"
  >
    {{ membership_type }}
  </div>
</div>
        </div>
      </div>
    </div>
    <ContentWrapperControl class="pt-4">
      <InfoGroupControl
        v-if="gender != null || date_of_birth != null"
        v-bind:title="lang('lbl_0000097')"
      >
        <InfoBarControl
          v-if="gender != null"
          v-bind:value="gender"
          v-bind:icon="getGenderIcon()"
          v-bind:title="lang('lbl_0000104')"
          :show_border="date_of_birth != null"
        />
        <InfoBarControl
          v-if="age != null"
          v-bind:value="age"
          icon="papsi_age.svg"
          v-bind:title="lang('lbl_0000103')"
          :show_border="date_of_birth != null"
        />
        <InfoBarControl
          v-if="date_of_birth != null"
          v-bind:value="date_of_birth"
          icon="papsi_date_of_birth.svg"
          v-bind:title="lang('lbl_0000105')"
          :show_border="false"
        />
      </InfoGroupControl>
      <InfoGroupControl
        v-show="!$store.state.express"
        v-bind:title="lang('lbl_0000079')"
      >
        <InfoBarControl
          v-bind:value="mobile"
          v-bind:title="lang('lbl_0000021')"
          icon="papsi_setting_mobile.svg"
          :show_border="email != null"
        />
        <InfoBarControl
          v-bind:value="email"
          v-bind:title="lang('lbl_0000022')"
          icon="papsi_setting_email.svg"
          :show_border="false"
        />
      </InfoGroupControl>
      <InfoGroupControl v-if="tin != null" v-bind:title="lang('lbl_0000100')">
        <InfoBarControl
          v-bind:value="tin"
          v-bind:title="lang('lbl_0000098')"
          icon="papsi_tax.svg"
          :show_border="false"
        />
      </InfoGroupControl>
      <InfoGroupControl v-bind:title="lang('lbl_0000101')">
        <InfoBarControl
          v-bind:value="username"
          v-bind:title="lang('lbl_0000041')"
          icon="papsi_setting_username.svg"
          :show_border="date != null"
        />
        <InfoBarControl
          v-bind:value="date"
          v-bind:title="lang('lbl_0000099')"
          icon="papsi_registered.svg"
          :show_border="false"
        />
      </InfoGroupControl>
    </ContentWrapperControl>
  </div>
</template>

<script>
import datetime from "date-and-time";
import parseMobile from "libphonenumber-js";
import ContentWrapperControl from "../components/controls/ContentWrapperControl.vue";
import InfoBarControl from "../components/controls/InfoBarControl.vue";
import InfoGroupControl from "../components/controls/InfoGroupControl.vue";
import ModalControl from "../components/controls/ModalControl.vue";
import mixin from "./../mixin.js";
import QrcodeVue from 'qrcode.vue'

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    InfoBarControl,
    InfoGroupControl,
    ModalControl,
    QrcodeVue,
  },
  data() {
    return {
      username: "",
      account_no: "",
      serial_no: "",
      name: "",
      gender: "",
      date_of_birth: "",
      membership_type: "",
      age: "",
      tin: "",
      type: "",
      email: "",
      mobile: "",
      date: "",
      display: false,
      loaded: false,
      size: 400,
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", false);
    this.$emit("shownavbar", {
      type: "primary",
    });

    let state = this.$store.state;

    if (state.login) {
      this.username = state.info.username;
      this.email = state.info.email;
      this.name = state.info.first_name + " " + state.info.last_name;
      this.account_no = state.info.account_no;
      this.serial_no = state.info.serial_no;
      this.membership_type = state.info.membership_type;
      this.date_of_birth =
        state.info.date_of_birth != null
          ? this.formatDate(state.info.date_of_birth)
          : null;
      this.age = state.info.age != null ? state.info.age.toString() : null;
      this.gender = state.info.gender;
      this.tin = state.info.tin;
      this.date =
        state.info.registered != null
          ? this.formatDate(state.info.registered)
          : null;
      this.type =
        state.info.type != null
          ? state.info.regular
            ? this.lang("lbl_0000095")
            : this.lang("lbl_0000096")
          : null;

      if (state.info.mobile_no != null) {
        let mobile = parseMobile(state.info.mobile_no, "PH")
          .formatNational()
          .split(" ");

        this.mobile = "(" + mobile[0] + ") " + mobile[1] + " " + mobile[2];
      }

      this.loadQr();
    }
  },
  methods: {
    getGenderIcon() {
      return this.gender.toLowerCase() == "male"
        ? "papsi_gender_male.svg"
        : "papsi_gender_female.svg";
    },
    loadQr() {
      let url = this.getCode(),
        that = this,
        img = new Image();
      img.src = url;
      img.onload = function () {
        let t = setTimeout(function () {
          that.loaded = true;
          clearTimeout(t);
        }, 1000);
      };
    },
    getSerial() {
      return this.serial_no != null ? this.serial_no : "??????";
    },
    getCode() {
      return (
        "https://quickchart.io/qr?text=" +
        this.$store.state.qr +
        "&size=" +
        this.size
      );
    },
    getLoader() {
      return process.env.VUE_APP_MEDIA_URL + "images/loader/gear-spinner.gif";
    },
    openQr() {
      this.display = true;
    },
    closed() {
      this.display = false;
    },
    formatDate(date) {
      return datetime.format(new Date(date), "MM/DD/YYYY");
    },
  },
};
</script>

<style scoped>
.papsi-avatar {
  width: 140px;
  height: 140px;
}
</style>
